// export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3100/api/game/';
export const API_URL_IMG = process.env.REACT_APP_API_URL_IMG || 'http://localhost:5001';

// O endereco da API vem do ambiente quando definido. Sem variavel, mantem exatamente o
// valor de producao que ja estava aqui — o build de producao nao muda em nada.
//
// Existe para o ambiente de homologacao: os vhosts de hml-* proxeiam /api/game para o
// backend de HML (porta 6101, banco credenciamento-hml). Com a URL absoluta de producao
// chumbada, um front publicado em HML escreveria na base do evento.
export const API_URL = process.env.REACT_APP_API_URL || 'https://credenciamento.quantictechnology.com.br/api/game/'